import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { HeaderArea } from './styled';
import { WHATSAPP_URL } from '../../WhatsAppButton';

const mainLinks = [
	{ to: '/', label: 'Home' },
	{ to: '/produtos', label: 'Produtos' },
	{ to: '/historia', label: 'Quem Somos' },
	{ to: '/contato', label: 'Contato' },
];

const socialLinks = [
	{ href: 'https://www.instagram.com/salato_alimentos/', label: 'Instagram', icon: require('../../../assets/images/instagram.png') },
	{ href: 'https://www.facebook.com/salatoalimentos', label: 'Facebook', icon: require('../../../assets/images/facebook.png') },
	{ href: WHATSAPP_URL, label: 'WhatsApp', icon: require('../../../assets/images/whatsApp.png') },
];

const Header = () => {
	const [open, setOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);
	const { pathname } = useLocation();

	// sombra e altura menor depois que a página rola
	useEffect(() => {
		let ticking = false;
		const onScroll = () => {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(() => {
				setScrolled(window.scrollY > 12);
				ticking = false;
			});
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	// fecha o menu ao trocar de página
	useEffect(() => setOpen(false), [pathname]);

	// trava a rolagem do fundo e fecha com Esc enquanto o menu está aberto
	useEffect(() => {
		if (!open) return undefined;
		const prev = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		const onKey = (e) => e.key === 'Escape' && setOpen(false);
		window.addEventListener('keydown', onKey);
		return () => {
			document.body.style.overflow = prev;
			window.removeEventListener('keydown', onKey);
		};
	}, [open]);

	const renderLinks = (onClick) => mainLinks.map((item) => (
		<li key={item.to}>
			<NavLink to={item.to} exact={item.to === '/'} activeClassName="active" onClick={onClick}>
				{item.label}
			</NavLink>
		</li>
	));

	return (
		<HeaderArea className={scrolled ? 'is-scrolled' : ''}>
			<div className="container">
				<button
					type="button"
					aria-label={open ? 'Fechar menu' : 'Abrir menu'}
					aria-expanded={open}
					onClick={() => setOpen(!open)}
					className={`menuButton${open ? ' is-open' : ''}`}
				>
					<span></span>
					<span></span>
					<span></span>
				</button>

				<Link to="/" className="logo" aria-label="Salato Alimentos — página inicial">
					<img src={require('../../../assets/images/logo-salato.png')} alt="Salato Alimentos" width="517" height="269" />
				</Link>

				<nav className="navMain" aria-label="Principal">
					<ul>{renderLinks()}</ul>
				</nav>

				<div className="navRight">
					<div className="socialArea">
						{socialLinks.map((s) => (
							<a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} title={s.label}>
								<img src={s.icon} alt="" width="22" height="22" />
							</a>
						))}
					</div>
					<Link to="/contato" className="ctaButton">Solicitar orçamento</Link>
				</div>
			</div>

			<div className={`mobileBackdrop${open ? ' is-open' : ''}`} onClick={() => setOpen(false)} aria-hidden="true"></div>

			<aside className={`mobileDrawer${open ? ' is-open' : ''}`} aria-hidden={!open}>
				<div className="drawerHeader">
					<img src={require('../../../assets/images/logo-salato.png')} alt="Salato Alimentos" />
				</div>
				<nav aria-label="Menu">
					<ul>{renderLinks(() => setOpen(false))}</ul>
				</nav>
				<Link to="/contato" className="ctaButton drawerCta" onClick={() => setOpen(false)}>Solicitar orçamento</Link>
				<div className="drawerSocial">
					{socialLinks.map((s) => (
						<a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}>
							<img src={s.icon} alt="" width="22" height="22" />
							<span>{s.label}</span>
						</a>
					))}
				</div>
			</aside>
		</HeaderArea>
	);
};

const mapStateToProps = (state) => ({
	nome: state.user.nome,
	qt: state.user.qt,
	StCart: state.user.StCart,
	DisplayNone: state.user.DisplayNone,
});

const mapDispatchToProps = (dispatch) => ({
	setNome: (nome) => dispatch({ type: 'SET_NOME', payload: { nome } }),
	setCart: (StCart) => dispatch({ type: 'SET_CART', payload: { StCart } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
